export enum QuoteType {
  Surgical,
  NonSurgical,
  Injection,
  PostSurgical,
  PostInjection,
}
